"use strict";

var _taggedTemplateLiteral = require("/codebuild/output/src213846038/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var styled_1 = __importDefault(require("@emotion/styled"));

var frontend_layout_1 = require("@ryerson/frontend.layout");

var frontend_typography_1 = require("@ryerson/frontend.typography");

var frontend_form_controls_1 = require("@ryerson/frontend.form-controls");

var frontend_button_1 = require("@ryerson/frontend.button");

var react_1 = require("@emotion/react");

var frontend_theme_1 = require("@ryerson/frontend.theme");

var ItemLink_1 = require("../common/ItemLink");

var frontend_quantity_uom_inputs_1 = require("@ryerson/frontend.quantity-uom-inputs");

var frontend_common_1 = require("@ryerson/frontend.common");

var frontend_application_1 = require("@ryerson/frontend.application");

var SearchResultsContext_v2_1 = require("./SearchResultsContext_v2");

var SearchResults_helpers_v2_1 = require("./SearchResults_helpers_v2");

var ResultItemWrapper = (0, styled_1.default)(frontend_layout_1.Flex)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\t&:not(:last-child) {\n\t\tmargin-bottom: 8px;\n\t}\n\tpadding-right: 10px;\n\t", ";\n"])), function (props) {
  var background = props.background,
      gap = props.gap;
  return (0, react_1.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\t\t\tbackground: ", ";\n\t\t\tgap: ", "px;\n\t\t"])), background, gap);
});
var PricingMeasureDropdown = (0, styled_1.default)(frontend_form_controls_1.Dropdown)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n\tfont-size: 14px;\n\ttext-transform: lowercase;\n"])));
var imageContainerWrapperStyles = (0, react_1.css)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n\tmargin-right: 15px;\n"])));
var dropdownInputStyles = (0, react_1.css)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n\twidth: 70px;\n"])));

var SearchResultItemDesktop = function SearchResultItemDesktop(_ref) {
  var item = _ref.item,
      qtyUomOption = _ref.qtyUomOption,
      pricingUomOption = _ref.pricingUomOption,
      quantity = _ref.quantity,
      quantityMeasure = _ref.quantityMeasure,
      pricingMeasure = _ref.pricingMeasure,
      isDebouncing = _ref.isDebouncing,
      hasError = _ref.hasError,
      setHasError = _ref.setHasError,
      leadTimeDays = _ref.leadTimeDays,
      addDefaultSrc = _ref.addDefaultSrc,
      getCorrectCase = _ref.getCorrectCase,
      canCartViewEdit = _ref.canCartViewEdit,
      generateProductUrl = _ref.generateProductUrl,
      onQuantityUpdate = _ref.onQuantityUpdate,
      onPricingMeasureChange = _ref.onPricingMeasureChange,
      onClickAddToCart = _ref.onClickAddToCart;

  var _ref2 = (0, frontend_theme_1.useTheme)(),
      theme = _ref2.theme;

  var _theme$colors$primary = theme.colors.primary,
      white = _theme$colors$primary.white,
      lighterGray = _theme$colors$primary.lighterGray,
      header = _theme$colors$primary.header;

  var _ref3 = (0, frontend_application_1.useApplication)(),
      language = _ref3.localization.language;

  var _ref4 = (0, SearchResultsContext_v2_1.useSearchResults)(),
      stateMessenger = _ref4.stateMessenger,
      storeDirectory = _ref4.storeDirectory,
      setSearchText = _ref4.setSearchText,
      content = _ref4.content;

  var itemCategory = getCorrectCase(item.category);
  var itemForm = getCorrectCase(item.form);
  var itemShape = item.shape !== "N/A" ? getCorrectCase(item.shape) : "";
  var imageSource = "/static-assets/images/renderings/".concat(itemCategory).concat(itemForm).concat(itemShape, ".png");
  var disableButton = quantity === 0 || typeof quantity === "undefined" || isDebouncing || hasError || leadTimeDays === undefined;
  return (0, jsx_runtime_1.jsxs)(ResultItemWrapper, {
    background: lighterGray,
    gap: 16,
    justifyContent: "space-between",
    children: [(0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
      children: [(0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
        style: imageContainerWrapperStyles,
        children: (0, jsx_runtime_1.jsx)(SearchResults_helpers_v2_1.ImageContainer, {
          bgColor: white,
          onError: function onError(event) {
            return addDefaultSrc(event);
          },
          src: imageSource
        })
      }), (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
        direction: "column",
        css: {
          maxWidth: 158,
          gap: 3
        },
        children: [(0, jsx_runtime_1.jsxs)(frontend_typography_1.Typography, {
          size: "xs",
          color: header,
          children: [item.category, " ", item.form]
        }), (0, ItemLink_1.getItemLink)(item, generateProductUrl, storeDirectory, setSearchText), (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
          size: "sm",
          color: header,
          children: item.description
        }), (0, jsx_runtime_1.jsxs)(frontend_typography_1.Typography, {
          size: "xs",
          color: header,
          children: [content.leadTime, ": ", (0, frontend_common_1.getLeadTimeRangeDisplay)(leadTimeDays, language)]
        })]
      })]
    }), (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
      direction: "column",
      css: {
        gap: 5
      },
      children: [(0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
        justifyContent: "flex-end",
        alignItems: "flex-start",
        gutter: 2,
        children: [(0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
          children: (0, jsx_runtime_1.jsxs)(frontend_typography_1.Typography, {
            size: "xs",
            children: [content.quantity, ":"]
          })
        }), (0, jsx_runtime_1.jsx)(frontend_quantity_uom_inputs_1.QuantityUOM, {
          quantityUomOptions: qtyUomOption,
          id: item.id,
          itemData: item,
          size: "sm",
          type: "primary",
          disabled: false,
          isSubmitted: true,
          quantityValue: Number(quantity),
          uomValue: quantityMeasure,
          handleValidationResponse: function handleValidationResponse(hasError) {
            return setHasError(hasError);
          },
          handleChange: onQuantityUpdate,
          stateMessenger: stateMessenger
        })]
      }), (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
        justifyContent: "flex-end",
        alignItems: "flex-start",
        gutter: 2,
        children: [(0, jsx_runtime_1.jsxs)(frontend_typography_1.Typography, {
          size: "xs",
          children: [content.priceUom, ":"]
        }), (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
          style: dropdownInputStyles,
          children: (0, jsx_runtime_1.jsx)(PricingMeasureDropdown, {
            size: "sm",
            onChange: onPricingMeasureChange,
            options: pricingUomOption,
            value: pricingMeasure,
            language: language
          })
        })]
      }), canCartViewEdit() && (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
        justifyContent: "flex-end",
        direction: "column",
        alignItems: "flex-end",
        css: {
          paddingTop: 2
        },
        children: (0, jsx_runtime_1.jsx)(frontend_button_1.Button, {
          fullwidth: true,
          onClick: onClickAddToCart,
          disabled: disableButton,
          size: "sm",
          label: content.addToCart,
          paddingType: "relaxed"
        })
      })]
    })]
  });
};

exports.default = SearchResultItemDesktop;